__turbopack_context__.v({
  "MuiTypography-root": "product_options-module-scss-module__xMMamG__MuiTypography-root",
  "active": "product_options-module-scss-module__xMMamG__active",
  "category_color_swatch": "product_options-module-scss-module__xMMamG__category_color_swatch",
  "chicklet_options": "product_options-module-scss-module__xMMamG__chicklet_options",
  "option": "product_options-module-scss-module__xMMamG__option",
  "option-list": "product_options-module-scss-module__xMMamG__option-list",
  "option-wrapper": "product_options-module-scss-module__xMMamG__option-wrapper",
  "product-option-img": "product_options-module-scss-module__xMMamG__product-option-img",
  "selected": "product_options-module-scss-module__xMMamG__selected",
  "show-more-btn": "product_options-module-scss-module__xMMamG__show-more-btn",
  "type-chicklet": "product_options-module-scss-module__xMMamG__type-chicklet",
  "type-color": "product_options-module-scss-module__xMMamG__type-color",
  "type-icon": "product_options-module-scss-module__xMMamG__type-icon",
});
